module.exports = __webpack_public_path__ + "static/lan-c48a85abec3c21b1b60acc7ef19424bd.svg";